import { render, staticRenderFns } from "./TransactionInfoModal.vue?vue&type=template&id=67eebed2&"
import script from "./TransactionInfoModal.vue?vue&type=script&lang=js&"
export * from "./TransactionInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports